module.exports = firebase;